import PropTypes from 'prop-types';
import { Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import ShowError from '../../showError';

const NotificationFormForEdit = ({
  status,
  loading,
  handleOnFinish = () => {},
  showApprove = true,
  showReject = true,
  showToAdim = true,
  showRefuse = true,
  approveKey,
  rejectKey,
  paramKey,
  backCount = 2,
  approveErrors = [],
  showInProgress = false,
  showConfirmTheRequest = false,
  confirmTheRequestKey,
  inProgressKey,
  dontBlockApprove,
}) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const onFinish = (values) => {
    handleOnFinish(values, paramKey, backCount);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = (status) => {
    return () => {
      form.setFieldsValue({ status });
      form.submit();
    };
  };

  if (!showApprove && !showReject && !showToAdim && !showRefuse) return null;

  return (
    <Form
      form={form}
      name='basic'
      wrapperCol={{
        span: 24,
      }}
      style={{ marginTop: '20px' }}
      initialValues={
        {
          // remember: true,
        }
      }
      layout={'vertical'}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete='off'
    >
      <Form.Item
        label={t('Inserisci notifica per il richiedente')}
        name='description'
      >
        <Input.TextArea
          rows={6}
          placeholder={'Inserisci notifica per il richiedente'}
        />
      </Form.Item>
      <Form.Item hidden name='status'>
        <Input />
      </Form.Item>
      <Row gutter={16}>
        {showApprove && (
          <Col>
            <Button
              loading={loading}
              upperCase
              type={status === 'status_confirmed' ? 'green' : 'primary'}
              disabled={status === 'status_confirmed' && !dontBlockApprove}
              onClick={onClickSave(approveKey || 'Approva')}
            >
              {status === 'status_confirmed' ? t('Approvato') : t('Approva')}
            </Button>
          </Col>
        )}
        {showReject && (
          <Col>
            <Button
              loading={loading}
              upperCase
              type={'red'}
              disabled={status === 'status_refused'}
              onClick={onClickSave(rejectKey || 'Rifiutato')}
            >
              {t('Rifiutato')}
            </Button>
          </Col>
        )}
        {showInProgress && (
          <Col>
            <Button
              loading={loading}
              upperCase
              type={'primary'}
              disabled={status === 'in_progress'}
              onClick={onClickSave(inProgressKey || 'Rifiutato')}
            >
              {t('Presa in carico')}
            </Button>
          </Col>
        )}
        {showConfirmTheRequest && (
          <Col>
            <Button
              loading={loading}
              upperCase
              type={'primary'}
              disabled={status === 'confirm_the_request'}
              onClick={onClickSave(confirmTheRequestKey)}
            >
              {t('Conferma la richiesta')}
            </Button>
          </Col>
        )}
        {showToAdim && (
          <Col>
            <Button
              loading={loading}
              type={'secondary'}
              disabled={status === 'status_to_admin'}
              upperCase
              onClick={onClickSave('Escalate to admin')}
            >
              {status === 'status_to_admin'
                ? t('Escalated to admin')
                : t('Escalate to admin')}
            </Button>
          </Col>
        )}
        {showRefuse && (
          <Col>
            <Button
              loading={loading}
              type={'secondary'}
              disabled={status === 'status_refused'}
              upperCase
              onClick={onClickSave('Annulla Intervento')}
            >
              {t('Annulla Intervento')}
            </Button>
          </Col>
        )}
      </Row>
      <ShowError errors={approveErrors} />
    </Form>
  );
};

NotificationFormForEdit.propTypes = {
  handleOnFinish: PropTypes.func,
  showApprove: PropTypes.bool,
  showReject: PropTypes.bool,
  showToAdim: PropTypes.bool,
  loading: PropTypes.bool,
};

export default NotificationFormForEdit;
